import type { ReactNode } from "react";
import { cn } from "./cn";

// Release 1 · Components §04 "Fact table": key / value rows. Key 13/500 at
// 72%, value 13/600 end-aligned. Money and times go in mono (`mono`). Rendered
// as a <dl> so each pair is read together.

export type Fact = { label: ReactNode; value: ReactNode; mono?: boolean };

export function FactRow({ label, value, mono, className }: Fact & { className?: string }) {
  return (
    <div className={cn("flex items-baseline justify-between gap-4 py-3.5", className)}>
      <dt className="text-[13px] leading-[1.4] font-medium text-muted">{label}</dt>
      <dd
        className={cn(
          "min-w-0 text-end text-[13px] leading-[1.4] text-ink",
          mono ? "mf-mono font-medium" : "font-semibold",
        )}
      >
        {value}
      </dd>
    </div>
  );
}

/** `bare` drops the card frame (a fact table inside a dialog's cost box or
 *  inside another card). */
export function FactTable({
  rows,
  children,
  bare,
  className,
}: {
  rows?: Fact[];
  /** FactRow children, if you'd rather compose. */
  children?: ReactNode;
  bare?: boolean;
  className?: string;
}) {
  return (
    <dl
      className={cn(
        "divide-y divide-line-soft",
        !bare && "rounded-lg border border-line bg-card px-4 py-0.5 md:rounded-md",
        className,
      )}
    >
      {rows?.map((r, i) => <FactRow key={i} {...r} />)}
      {children}
    </dl>
  );
}
